// @ts-nocheck
// oxlint-disable no-unused-vars
import type {
	ApiResponseOfFurnitureItemDto,
	ApiResponseOfIReadOnlyListOfFurnitureItemDto,
	FurnitureItemRequest,
} from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * DELETE `/furniture/${id}`
 */
export const deleteApiFurnitureById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponse<null>>({
		uri: `furniture/${id}`,
		method: "DELETE",
	});

/**
 * GET `/furniture`
 */
export const getApiFurniture = (query: {
	/** @format uuid */
	projectId: string;
}) =>
	apiFetch<ApiResponseOfIReadOnlyListOfFurnitureItemDto>({
		uri: "furniture",
		method: "GET",
		query: query,
	});

/**
 * POST `/furniture`
 */
export const postApiFurniture = (data: FurnitureItemRequest) =>
	apiFetch<ApiResponseOfFurnitureItemDto>({
		uri: "furniture",
		method: "POST",
		body: data,
	});

/**
 * PUT `/furniture/${id}`
 */
export const putApiFurnitureById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: FurnitureItemRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `furniture/${id}`,
		method: "PUT",
		body: data,
	});
